<script setup>
import {ref, defineEmits, defineProps, onMounted} from 'vue';
import {required, validSelection} from '@ohrm/core/util/validation/rules';
import TrainingAutocomplete from './TrainingAutocomplete.vue';
import MultiChips from '@ohrm/oxd/core/components/Input/MultiSelect/MultiSelectChips.vue';

const props = defineProps({
  operator: {
    type: Object,
    required: false,
    default: () => null,
  },
  valueX: {
    type: Object,
    required: false,
    default: () => null,
  },
  valueY: {
    type: Object,
    required: false,
    default: () => null,
  },
  criterion: {
    type: Object,
    required: false,
    default: () => null,
  },
});
const emit = defineEmits(['update:valueX', 'update:operator']);

const rules = [required, validSelection];
const selectedTrainings = ref([]);

const addTraining = event => {
  if (
    !selectedTrainings.value.find(e => e?.id === event?.id) &&
    typeof event === 'object'
  ) {
    selectedTrainings.value.push(event);
    emit('update:valueX', selectedTrainings.value);
  }
};

const removeTraining = id => {
  const index = selectedTrainings.value.findIndex(e => e.id === id);
  selectedTrainings.value.splice(index, 1);
  emit('update:valueX', selectedTrainings.value);
};

onMounted(() => {
  emit('update:operator', {id: 'eq', label: 'Equal'});
  if (props.valueX) {
    selectedTrainings.value = props.valueX;
  }
});
</script>

<template>
  <oxd-grid-item>
    <training-autocomplete
      v-bind="$attrs"
      :rules="rules"
      :model-value="valueX"
      @update:modelValue="addTraining"
    ></training-autocomplete>
  </oxd-grid-item>
  <oxd-grid-item class="flex items-center --span-column-2">
    <MultiChips
      :selected="selectedTrainings"
      @chipRemoved="emp => removeTraining(emp.id)"
    />
  </oxd-grid-item>
</template>

<style lang="scss" scoped>
::v-deep(.oxd-input-group__label-wrapper) {
  display: none;
}
</style>
